import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export function Reveal({
  children,
  as: Tag = "div",
  className = "",
  delay = 0,
  y = 24,
  once = true,
  amount = 0.2,
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount, margin: "0px 0px -8% 0px" });
  const MotionTag = motion[Tag] || motion.div;

  return (
    <MotionTag
      ref={ref}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </MotionTag>
  );
}

export function Stagger({ children, className = "", delay = 0.06 }) {
  return (
    <div className={className}>
      {Array.isArray(children)
        ? children.map((child, i) => (
            <Reveal key={i} delay={i * delay}>
              {child}
            </Reveal>
          ))
        : children}
    </div>
  );
}
